import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import axios from 'axios';
import Header from 'components/UI/Header/Header';
import Footer from 'components/UI/Footer/Footer';
import Sections from 'components/sections/Sections';
import { Redirect } from "react-router-dom";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from 'react-loader-spinner';



const Firedown = () => {
    const [isLoading, setIsLoading] = useState(false)

    const fetchJob = () => {
        setIsLoading(true);
        var tracker = 0
        console.log("moving...")
        const fireInterval = setInterval(() => {
          tracker = tracker + 1
          console.log(tracker)
          //axios.get('http://localhost:8000/scrape')
          axios.get('https://newboardserver.herokuapp.com/scrape')
          .then((response) => {
            console.log(response.data)
          })
          .catch(() =>{
            alert('Error fetching new users')
          });
          if(tracker >= 60){
            clearInterval(fireInterval)
            setIsLoading(false)
            console.log("...returned")
          }
        }, 55000);
      }

  return (
      <div>
      <Header />
        <br/>
        <div class="page-container">
            <h3 align="center">ROLLERS</h3>
            <div>
                {
                isLoading ? 
                (
                  <button align='center' class="btn btn-primary" type="button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Firing...
                  </button>
              ) : (
                <div>
                  <button align='center' color="primary" class="btn btn-primary" onClick={fetchJob} >
                    Fire
                  </button>
                </div>
              )
              }
            </div>
        </div>
        <br/>
      <Footer />
      </div>
  );
};

export default Firedown;